<template>
  <div>
    <!-- <filed v-for="(item,key) in arr" :key="key" @titleTxt="title(value,key)"></filed> -->

    <div class="container">
      <Space v-if="getControl() == 1">
        &nbsp;&nbsp;企业代码：
        <Input v-model="ClientCode" @click="SelectClientSwitch = !SelectClientSwitch" placeholder="企业代码"
          style="width: 100px" />
        <br />
        <br />
      </Space>
      <Space>
        &nbsp;&nbsp;产品编号：
        <Input v-model="title1" placeholder="编号" style="width: 200px" />
      </Space>
      <br />
      <br />

      <Space>
        &nbsp;&nbsp;图片内容：
        <Input v-model="imgObj.title" placeholder="图片字段标题" style="width: 200px" />
        <br /><br />
        <FiledUpload :imgArr="imgObj.imgarr" @addImg="addImgArr"></FiledUpload>
      </Space><br />
      <Space> &nbsp;&nbsp;文本字段：（流水号=“@serial@”） </Space>

      <!-- 文本字段 -->
      <div class="container" v-for="(item, key) in arr" :key="key">
        <div class="containers" v-if="item.type == 'text'">
          <br />
          <Input disabled v-model="arr[key].title" placeholder="标题" style="width: 100px" />
          <span class="line">&nbsp;-&nbsp;</span>
          <Input v-model="arr[key].message" placeholder="内容" style="width: 300px" />
          <!-- <div class="jian" @click="jian(key)">
            <img
              class="jian_img"
              src="@/assets/images/jian.png"
              alt=""
              srcset=""
            />
          </div> -->
          <br />
        </div>
      </div>

      <br />
      &nbsp;&nbsp;
      <!-- <Button type="info" @click="add()">新增字段</Button>&nbsp; -->

      <Space>
        &nbsp;&nbsp;备注说明：
        <Input v-model="remark" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }" placeholder="请输入说明..."></Input>
      </Space>
    </div>
    <div class="btn">
      <Button @click="echo()" type="success" style="width: 100px; height: 40px">保&nbsp;存</Button>
    </div>

    <!-- 选择企业 -->
    <transition name="fade">
      <SelectClient v-if="SelectClientSwitch" @Value="SelectClientVal" @close="SelectClientClose"></SelectClient>
    </transition>
  </div>
</template>

<script>
import FiledUpload from "@/views/FiledUpload";
import { NewProductList, GetProductCustomAll } from "@/api/index";
import SelectClient from "@/views/selectClient";
import { mapState } from "vuex";
export default {
  data() {
    return {
      number: 10,
      title1: "",
      ClientCode: "1001",
      imgObj: {
        title: "产品图片",
        type: "img",
        imgarr: [],
      },
      arr: [
        {
          title: "产品名称",
          type: "text",
          message: "",
        },
      ],
      remark: "",
      SelectClientSwitch: false,
    };
  },
  components: {
    SelectClient,
    FiledUpload,
  },
  watch: {},
  computed: mapState({
    control: (state) => state.control,
  }),
  created() {
    this.GetProductCustomAlls();
    //   console.log('1-'+this.control);
  },
  methods: {
    // 获取自定义字段列表
    GetProductCustomAlls() {
      GetProductCustomAll({}).then((res) => {
        console.log(res);
        for (let i = 0; i < res.length; i++) {
          this.arr.push({ title: res[i], type: "text", message: "" });
        }
      });
    },
    getControl() {
      return this.control;
    },
    // 添加图片
    addImgArr(value) {
      this.imgObj.imgarr.push(value);
    },
    SelectClientClose() {
      this.SelectClientSwitch = false;
    },
    SelectClientVal(value) {
      this.ClientCode = value;
      this.SelectClientSwitch = false;
    },
    propsTitleVal(key) {
      return this.arr[key].title;
    },
    propsMessageVal(key) {
      return this.arr[key].message;
    },
    add() {
      this.arr.push({ title: "", type: "text", message: "" });
    },
    // 完成按钮
    echo() {
      var ab = this.arr;
      let type = "文本";
      if (this.imgObj.imgarr.length !== 0) {
        ab.unshift(this.imgObj);
        type = "文本,图片";
      }
      let datas = ab;
      if (this.title1 == "") {
        this.$message({
          type: "error",
          message: "产品编号不要留空哦！",
        });
      } else {
        NewProductList({
          clientcode: this.ClientCode,
          dataType: type,
          datas: JSON.stringify(datas),
          titless: this.title1,
          remark: this.remark,
        }).then((res) => {
          if (res == 1) {
            this.$emit("close", true);
          } else if (res == "reuse") {
            this.$message({
              type: "error",
              message: "产品编号已经被使用了,请重新设置",
            });
          }
        });
      }
    },
    title(event, key) {
      this.arr[key].title = event;
    },
    message(event, key) {
      this.arr[key].message = event;
    },
    jian(key) {
      // console.log(key);
      this.arr[key] = {};
      this.arr.splice(key, 1);
    },
  },
};
</script>

<style scoped >
.container {
  max-height: calc(100% - 100px);
}

.containers {
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 10px;
}

.line {
  line-height: 32px;
}

.jian {
  margin-left: 10px;
  height: 32px;
  width: 32px;
  cursor: pointer;
}

.jian_img {
  width: 100%;
}
</style>
